export const VERSION = {
  appVersion: '1.1.1-22',
  buildDate: '2025-1-30 11:18:49',
};
